module.exports = __webpack_public_path__ + "img/duiwubtns.13da3e28.png";